import useFeatureFlagStore from '~/domain/shared/feature-flag/stores/useFeatureFlagStore'
import { COMING_SOON_PRODUCT_PATHS } from '~/domain/shared/product-apps/models/ComingSoonProduct'

export const CPLUG_DELIVERY_FEATURE_FLAG = 'cplug_delivery'
export const ONLINE_STORE_HOME_PATH = '/dashboard/store/general'

export function isOnlineStoreMenuEnabled (): boolean {
  return useFeatureFlagStore().isEnabled(CPLUG_DELIVERY_FEATURE_FLAG)
}

export function isOnlineStoreRoute (path: string): boolean {
  return path === '/dashboard/store' || path.startsWith('/dashboard/store/')
}

export function isLojaInterestRoute (path: string): boolean {
  const interestPath = COMING_SOON_PRODUCT_PATHS.loja
  return path === interestPath || path.startsWith(`${interestPath}/`)
}

export function resolveOnlineStoreDestination (path: string, enabled: boolean): string | null {
  if (!enabled && isOnlineStoreRoute(path)) {
    return COMING_SOON_PRODUCT_PATHS.loja
  }

  if (enabled && isLojaInterestRoute(path)) {
    return ONLINE_STORE_HOME_PATH
  }

  return null
}
